import { render, staticRenderFns } from "./customer_comment.vue?vue&type=template&id=78051a45&scoped=true"
import script from "./customer_comment.vue?vue&type=script&lang=ts"
export * from "./customer_comment.vue?vue&type=script&lang=ts"
import style0 from "./customer_comment.vue?vue&type=style&index=0&id=78051a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78051a45",
  null
  
)

export default component.exports